module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__hotel--active-284d4b19382a2e2f125f06df6c62c199.svg";